import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IViewer } from '@/contracts/system-modules/share/IViewer'

export class GetViewersRoute extends ShareRoute<null, IViewer[]> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/share/viewers'
  }

  /** Без сервера зрителей нет */
  offline(): Promise<ApiResponse<IViewer[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
